import { NgModule } from '@angular/core';

import { RouterModule, Routes } from '@angular/router';

import { AccountLayoutComponent } from './account-layout/account-layout.component';
import { AccountComponent } from './account/account.component';
import { BillingComponent } from './billing/billing.component';
import { ConnectionsComponent } from './connections/connections.component';
import { PreferencesComponent } from './preferences/preferences.component';
import { ProfileComponent } from './profile/profile.component';
import { UsersComponent } from './users/users.component';
import { UsersGuard } from './users/users.guard';

const routes: Routes = [
  {
    path: '',
    component: AccountLayoutComponent,
    children: [
      {
        path: '',
        component: AccountComponent,
        data: { title: 'My Account' }
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: { title: 'Profile' }
      },
      {
        path: 'users',
        canActivate: [UsersGuard],
        component: UsersComponent,
        data: { title: 'Users' }
      },
      {
        path: 'connections',
        component: ConnectionsComponent,
        data: { title: 'Connections' }
      },
      {
        path: 'connections/:service',
        component: ConnectionsComponent,
        data: { title: 'Connections' }
      },
      {
        path: 'preferences',
        component: PreferencesComponent,
        data: { title: 'Preferences' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule {}
